import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { TransitionProps } from '@mui/material/transitions';
import Slide from '@mui/material/Slide';
import { Box, OutlinedInput } from '@mui/material';

export interface DefaultDialogInputProps {
    rows?: number;
    value?: string;
}

export interface DefaultDialogProps {
    title: string;
    message: string;
    children?: React.ReactNode;
    open: boolean;
    type?: "question" | "information";
    onYesClick?: (e?: any | undefined) => void;
    onNoClick?: (e?: any | undefined) => void;
    onClose: () => void;
    inputProps?: DefaultDialogInputProps;

}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function DefaultDialog(props: DefaultDialogProps) {
    const [dialogProps, setDialogdialogProps] = useState<DefaultDialogProps>(props);
    const [value, setValue] = useState<string>(props.inputProps?.value || "");
    const inputRef = React.useRef<HTMLElement>(null);

    useEffect(() => {
        setDialogdialogProps(props);
        setValue(props.inputProps?.value || "");
    }, [props.open]);

    const handleChange = (event: any) => {
        setValue(event.target.value);
    };

    const handleYesClick = () => {
 

        if (dialogProps.onYesClick !== undefined) {
            dialogProps.onYesClick(value);
        }

        dialogProps.onClose();
    };

    const handleEntering = () => {
        if (inputRef.current != null) {
            inputRef.current.focus();
        }
    };

    const handleNoClick = () => {

        if (dialogProps.onNoClick !== undefined) {
            dialogProps.onNoClick(value);
        }
        dialogProps.onClose();
    };

    const getTitle = () => {
        if (dialogProps.title === undefined) {
            if (dialogProps.type === "question" || dialogProps.type === undefined) {
                return "Pergunta";
            } else if (dialogProps.type === "information") {
                return "Informação";
            }
        }
        return dialogProps.title
    };

    const getButtons = () => {
        if (dialogProps.type === undefined || dialogProps.type === "question") {
            return (
                <React.Fragment>
                    <Button
                        onClick={handleNoClick}
                        variant='outlined'
                        autoFocus
                        sx={{
                            minWidth: 100,
                            textTransform: 'none',
                            fontWeight: 500,
                            fontSize: '0.9rem',
                        }}
                    >
                        Não
                    </Button>
                    <Button
                        onClick={handleYesClick}
                        variant='contained'
                        sx={{
                            minWidth: 100,
                            textTransform: 'none',
                            fontWeight: 500,
                            fontSize: '0.9rem',
                        }}
                    >
                        Sim
                    </Button>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <Button
                        onClick={handleYesClick}
                        variant='contained'
                        sx={{
                            minWidth: 100,
                            textTransform: 'none',
                            fontWeight: 500,
                            fontSize: '0.9rem',
                        }}
                    >
                        Ok
                    </Button>
                </React.Fragment>
            );
        }
    };

    return (
        <Dialog
            open={dialogProps.open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            TransitionProps={{ onEntering: handleEntering }}
            sx={{ zIndex: 10000000 }}
            TransitionComponent={Transition}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                elevation: 8,
                sx: {
                    borderRadius: 2,
                    minWidth: { xs: '90%', sm: 400 },
                }
            }}
        >
            <DialogTitle
                id="alert-dialog-title"
                sx={{
                    fontSize: '1.25rem',
                    fontWeight: 600,
                    color: 'text.primary',
                    pb: 1.5,
                    pt: 3,
                    px: 3,
                }}
            >
                {getTitle()}
            </DialogTitle>
            <DialogContent
                dividers
                sx={{
                    minHeight: "120px",
                    px: 3,
                    py: 2.5,
                    borderColor: 'divider',
                }}
            >
                <DialogContentText
                    id="alert-dialog-description"
                    sx={{
                        fontSize: '0.95rem',
                        color: 'text.secondary',
                        lineHeight: 1.6,
                        mb: 0,
                    }}
                >
                    {dialogProps.message}
                    {dialogProps !== undefined && dialogProps.inputProps !== undefined && (
                        <React.Fragment>
                            <Box sx={{ mt: 2.5 }}>
                                <OutlinedInput
                                    ref={inputRef}
                                    multiline={dialogProps.inputProps.rows !== undefined}
                                    value={dialogProps.inputProps.value}
                                    onBlur={handleChange}
                                    onChange={handleChange}
                                    rows={dialogProps.inputProps.rows}
                                    name='input-justification'
                                    fullWidth
                                    sx={{
                                        fontSize: '0.9rem',
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: 'divider',
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: 'primary.main',
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderWidth: 2,
                                        }
                                    }}
                                />
                            </Box>
                        </React.Fragment>
                    )
                    }
                </DialogContentText>
            </DialogContent>
            <DialogActions
                sx={{
                    px: 3,
                    py: 2,
                    gap: 1.5,
                }}
            >
                {getButtons()}
            </DialogActions>
        </Dialog>
    );

}

